import React from 'react'
/* import PropTypes from 'prop-types' */
import {Icon} from '@chakra-ui/react'

const InfoIcon = ({/* circleColor, */ ...props}) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="info-icon" {...props}>
            <g clipPath="url(#clip0_31_638)">
                <g clipPath="url(#clip1_31_638)">
                    <path
                        d="M18.1393 18.9333C19.6327 18.88 20.9927 18.6667 21.8193 18.1067C22.5393 17.6533 23.0993 16.8533 23.0993 15.7333C23.0993 14.1067 21.8993 12.88 20.2193 12.88C18.406 12.88 17.3393 14.2667 17.286 15.7867H14.166C14.2993 12.3467 16.8327 10 20.326 10C24.006 10 26.2727 12.5867 26.2727 15.68C26.2727 18.5333 24.2993 20.56 21.1527 21.0133V23.6267H18.1393V18.9333ZM17.526 27.7333C17.526 26.5867 18.406 25.68 19.5793 25.68C20.7527 25.68 21.6593 26.5867 21.6593 27.7333C21.6593 28.9067 20.726 29.8133 19.5793 29.8133C18.4327 29.8133 17.526 28.9067 17.526 27.7333Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.001 37.0833C29.4358 37.0833 37.0843 29.4349 37.0843 20C37.0843 10.5651 29.4358 2.91667 20.001 2.91667C10.5661 2.91667 2.91764 10.5651 2.91764 20C2.91764 29.4349 10.5661 37.0833 20.001 37.0833ZM20.001 40C31.0467 40 40.001 31.0457 40.001 20C40.001 8.9543 31.0467 0 20.001 0C8.95528 0 0.000976562 8.9543 0.000976562 20C0.000976562 31.0457 8.95528 40 20.001 40Z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_31_638">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.000244141)"
                    />
                </clipPath>
                <clipPath id="clip1_31_638">
                    <rect width="40" height="40" fill="white" transform="translate(-0.000976562)" />
                </clipPath>
            </defs>
        </Icon>
    )
}
/* 
InfoIcon.propTypes = {circleColor: PropTypes.string} */
export default InfoIcon
